import { h } from 'preact';
import * as BaseComp from 'components/bolt/socialWall/socialWall.js';
// import s from 'components/bolt/socialWall/socialWall.sss';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';
import Store from 'store/store';
import { getDynamicData } from 'utils/bolt/dynamicData';

const DYNAMIC_KEYS = {
	homeCommunity: 'landing',
	utdCommunity: 'utd',
};
export default class SocialWall extends BaseComp.default {
	constructor(props) {
		super(props);


		this.handleClick = this.handleClick.bind(this);
		this.onVidPlay = this.onVidPlay.bind(this);
		this.onVidPause = this.onVidPause.bind(this);
	}

	async componentDidMount() {
		super.componentDidMount?.();
		observeScroll(this.base, { once: true });
		document.body.addEventListener('click', (event) => this.handleClick(event, this.props.id), true);
		document.body.addEventListener('play', (event) => this.onVidPlay(event, this.props.id), true);
		document.body.addEventListener('pause', (event) => this.onVidPause(event, this.props.id), true);

		const dynamicKey = DYNAMIC_KEYS[this.props.id];
		if (this.props.appData?.options?.cmsManaged && dynamicKey) {
			const dynamicData = await getDynamicData(dynamicKey);
			if (dynamicData) {
				this.dynamicData = dynamicData;
				this.setState({});
			}
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();

		unobserveScroll(this.base);
		document.body.removeEventListener('click', this.handleClick, true);
		document.body.removeEventListener('play', this.onVidPlay, true);
		document.body.removeEventListener('pause', this.onVidPause, true);
	}

	renderHeading(originalHeading, fontStyles) {
		const dynamicHeading = this.dynamicData?.socialWall?.title;
		return super.renderHeading(dynamicHeading || originalHeading, fontStyles);
	}

	getWall(originalId, originalFeed = 'default') {
		const dynamicId = this.dynamicData?.socialWall?.curatorId;
		const dynamicFeed = this.dynamicData?.socialWall?.feed;
		return super.getWall(dynamicId || originalId, dynamicFeed || originalFeed);
	}

	handleClick(e, id) {				
	
		let btnName = e.target?.parentElement?.className;
		if (btnName.length > 0 ) {
			if (btnName == 'crt-load-more-container' || btnName.includes('crt-panel-arrow')) {
				let label = btnName.includes('next') ? 'next' : btnName.includes('prev') ? 'prev' : 'load more';
				Store.emit('CUSTOM_EVENT', {
					category: id,
					action: 'social-wall-load-click',
					label: label
				});
			} else if (btnName == 'crt-play' || btnName == 'crt-video-container ') {
				Store.emit('CUSTOM_EVENT', {
					category: id,
					action: 'social-post-click',
				});
			}
		}
	}

	onVidPlay(e, id) {	
		if (e.target?.parentElement?.className === 'popup-video-container') {
			Store.emit('CUSTOM_EVENT', {
				category: id,
				action: 'social-video-play',
			});
		}
	}

	onVidPause(e, id) {	
		if (e.target?.parentElement?.className === 'popup-video-container') {
			Store.emit('CUSTOM_EVENT', {
				category: id,
				action: 'social-video-pause',
			});
		}
	}
}
